// @flow
import * as React from 'react';
import GalleryPicker from 'components/GalleryPicker';
import Field from './Field';

const GalleryPickerField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label?: string,
  description?: string
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <GalleryPicker
        id={id}
        name={name}
        values={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default GalleryPickerField;
